let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l0sql")).then(() => parcelRequire('gGFAO'));